
import { baseClasses } from '@weatherbug/common';
import { StatesByCountryType, CountriesByContinentResult, CitiesByCountryOrStateResult } from '../../components/sitemap/common/types';

const sitemapBaseUri = '/api/sitemap';
const sitemapStatesByCountryUri = '/api/sitemap/states';
const sitemapCountriesByContinentUri = '/api/sitemap/countriesbycontinent';
const sitemapCitiesByCountry = '/api/sitemap/citiesbycountry';
const sitemapTop200CitiesByState = '/api/sitemap/top200citiesbystate';
const getSitemapCountriesByContinentKey = 'getSitemapCountriesByContinentKey';
const getSitemapStatesByCountryKey = 'getSitemapStatesByCountryKey';
const getSitemapCitiesByCountryKey = 'getSitemapCitiesByCountryKey';
const getSitemapCitiesByStateKey = 'getSitemapCitiesByStateKey';

const { PulseBaseProvider } = baseClasses;

const getCountriesByContinentValidationFunction = (result: CountriesByContinentResult) => {
    return result?.Result?.length > 0;
};

const getStatesByCountryValidationFunction = (result: StatesByCountryType[]) => {
    return result?.length > 0;
};

const getCitiesByCountryOrStateValidationFunction = (result: CitiesByCountryOrStateResult) => {
    return result?.Result && result?.Result.length > 0;
};

export class SitemapProvider extends PulseBaseProvider {
    constructor(authId?: string, secret?:string, options?: any, logger?: any) {
        super(authId, secret, options, logger);
        window.storage.sync[getSitemapCountriesByContinentKey] = this.getCountriesByContinentSyncer.bind(this);
        window.storage.sync[getSitemapStatesByCountryKey] = this.getStatesByCountrySyncer.bind(this);
        window.storage.sync[getSitemapCitiesByCountryKey] = this.getCitiesByCountrySyncer.bind(this);
        window.storage.sync[getSitemapCitiesByStateKey] = this.getTop200CitiesByStateSyncer.bind(this);
    }

    async getCountriesByContinentSyncer(params: any) {
        const { id, syncParams, resolve, reject } = params;
        const { pulseApi, key } = syncParams;
        const parsedQParams = JSON.parse(id);
        const queryParams = {
            continent: parsedQParams.continent
        };
        return await super.syncData(key, id, queryParams, sitemapCountriesByContinentUri, resolve, reject, getCountriesByContinentValidationFunction, pulseApi, null, null, false);
    }

    async getCountriesByContinent(continent: string): Promise<CountriesByContinentResult | any> {
        const syncParams = {
            continent
        };
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(getSitemapCountriesByContinentKey, id, syncParams);
    }

    async getStatesByCountrySyncer(params: any) {
        const { id, syncParams, resolve, reject } = params;
        const { pulseApi, key } = syncParams;
        
        return await super.syncData(key, id, {}, sitemapStatesByCountryUri, resolve, reject, getStatesByCountryValidationFunction, pulseApi, null, null, false);
    }

    async getStatesByCountry(): Promise<StatesByCountryType[] | any> {
        const syncParams = {};
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(getSitemapStatesByCountryKey, id, syncParams);
    }

    async getCitiesByCountrySyncer(params: any) {
        const { id, syncParams, resolve, reject } = params;
        const { pulseApi, key } = syncParams;
        const parsedQParams = JSON.parse(id);
        const queryParams = {
            country: parsedQParams.country
        };
        return await super.syncData(key, id, queryParams, sitemapCitiesByCountry, resolve, reject, getCitiesByCountryOrStateValidationFunction, pulseApi, null, null, false);
    }

    async getCitiesByCountry(country: string): Promise<CitiesByCountryOrStateResult | any> {
        const syncParams = {
            country
        };
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(getSitemapCitiesByCountryKey, id, syncParams);
    }
    
    async getTop200CitiesByStateSyncer(params: any) {
        const { id, syncParams, resolve, reject } = params;
        const { pulseApi, key } = syncParams;
        const parsedQParams = JSON.parse(id);
        const queryParams = {
            state: parsedQParams.state
        };
        return await super.syncData(key, id, queryParams, sitemapTop200CitiesByState, resolve, reject, getCitiesByCountryOrStateValidationFunction, pulseApi, null, null, false);
    }

    async getTop200CitiesByState(state: string): Promise<CitiesByCountryOrStateResult | any> {
        const syncParams = {
            state
        };
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(getSitemapCitiesByStateKey, id, syncParams);
    }
}
